import { ScreenLabel, DisplayText, BodyText } from "../../components/mobile/primitives";
import { OnboardingFooter } from "./journey-shared";

export function JourneyProcessingScreen() {
  const steps = [
    { done: true, label: "Syncing Apple Health data", detail: "30 nights imported" },
    { done: true, label: "Parsing lab report PDF", detail: "5 biomarkers extracted" },
    { done: true, label: "Building health timeline", detail: "Cross-referencing sources" },
    { done: false, label: "Indexing for your skill", detail: null },
  ];

  return (
    <div
      style={{
        padding: "16px 16px 0",
        display: "flex",
        flexDirection: "column",
        gap: 0,
        height: "100%",
        position: "relative",
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: 24, textAlign: "center" }}>
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            background: "rgba(91,122,102,0.12)",
            border: "1px solid rgba(91,122,102,0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 12px",
          }}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--color-kin-green-soft)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>
        <ScreenLabel style={{ marginBottom: 5, display: "block" }}>Step 3 of 4</ScreenLabel>
        <DisplayText size={20}>Organizing your data</DisplayText>
        <BodyText
          size={9.5}
          color="var(--color-kin-muted)"
          weight={400}
          style={{ marginTop: 4, lineHeight: 1.45 }}
        >
          This takes a moment. You can leave this screen, and we'll notify you when your first
          dashboard is ready.
        </BodyText>
      </div>

      {/* Timeline */}
      <div style={{ position: "relative", display: "flex", flexDirection: "column", gap: 0 }}>
        {/* Connecting line */}
        <div
          style={{
            position: "absolute",
            left: 8,
            top: 9,
            bottom: 20,
            width: 1.5,
            background:
              "linear-gradient(to bottom, rgba(91,122,102,0.40) 0%, rgba(91,122,102,0.40) 70%, rgba(165,144,255,0.30) 70%)",
          }}
        />

        {steps.map((step, i) => {
          const isActive = !step.done;
          const isLast = i === steps.length - 1;
          return (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 14,
                paddingBottom: isLast ? 0 : 18,
              }}
            >
              <div style={{ marginTop: 3, flexShrink: 0, position: "relative", zIndex: 1 }}>
                {step.done ? (
                  <svg width="17" height="17" viewBox="0 0 17 17">
                    <circle cx="8.5" cy="8.5" r="8.5" fill="var(--color-kin-green-soft)" />
                    <path
                      d="M5 8.5 L7.3 10.8 L12 6.2"
                      stroke="#fff"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <div
                    style={{
                      width: 17,
                      height: 17,
                      borderRadius: "50%",
                      background: "rgba(165,144,255,0.12)",
                      border: "2px solid var(--color-kin-lavender)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        width: 5,
                        height: 5,
                        borderRadius: "50%",
                        background: "var(--color-kin-lavender)",
                      }}
                    />
                  </div>
                )}
              </div>
              <div style={{ flex: 1 }}>
                <BodyText
                  size={isActive ? 11.5 : 10.5}
                  color={
                    isActive
                      ? "var(--color-kin-black)"
                      : step.done
                        ? "var(--color-kin-black)"
                        : "var(--color-kin-muted)"
                  }
                  weight={isActive ? 700 : 600}
                >
                  {step.label}
                </BodyText>
                {step.detail && (
                  <BodyText
                    size={8.5}
                    color="var(--color-kin-muted)"
                    weight={400}
                    style={{ marginTop: 1 }}
                  >
                    {step.detail}
                  </BodyText>
                )}
                {isActive && (
                  <BodyText
                    size={8.5}
                    color="var(--color-kin-lavender)"
                    weight={600}
                    style={{ marginTop: 2 }}
                  >
                    In progress…
                  </BodyText>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Progress bar */}
      <div style={{ marginTop: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
          <ScreenLabel>Progress</ScreenLabel>
          <BodyText size={9} color="var(--color-kin-green-soft)" weight={700}>
            75%
          </BodyText>
        </div>
        <div
          style={{ height: 6, borderRadius: 3, background: "rgba(0,0,0,0.06)", overflow: "hidden" }}
        >
          <div
            style={{
              width: "75%",
              height: "100%",
              borderRadius: 3,
              background:
                "linear-gradient(90deg, var(--color-kin-green-soft), var(--color-kin-green-soft))",
            }}
          />
        </div>
      </div>

      {/* Continue — greyed out, processing not done */}
      <OnboardingFooter label="Waiting for data…" enabled={false} showSkip={true} />
    </div>
  );
}
